module.exports = __webpack_public_path__ + "static/media/website-designsteins-2019.5da5a8e9.png";